import { CustomerActivityType } from "@redotech/redo-customer-segments-common/marketing/segments/segment-types";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getTokenFieldOptions = {
  name: "getTokenFieldOptions" as const,
  description:
    "Values a token filter on a customer activity accepts, such as the products, collections or campaigns this store actually has. Call it for any catalog field with needsTokenOptions; the values are per-store and not guessable.",
  mutates: false,
  input: z.object({
    dataStructureType: createEnum(CustomerActivityType),
    dataStructureField: z.string(),
    searchString: z.string().optional(),
  }),
  output: z.object({ items: z.array(z.string()) }),
};
